import { Link } from "react-router-dom";
import { Download } from "lucide-react";
import { Logo } from "@/components/Header";
import { useLang } from "@/lib/i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-[#0B192C] text-slate-300" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 grid gap-8 sm:grid-cols-3">
        <div className="space-y-3">
          <Logo white className="h-11" />
          <p className="text-sm text-slate-400">{t("footer_tag")}</p>
        </div>
        <div className="grid gap-2 text-sm">
          <Link to="/search" className="hover:text-white" data-testid="footer-search-link">{t("nav_search")}</Link>
          <Link to="/register?role=owner" className="hover:text-white" data-testid="footer-owners-link">{t("nav_owners")}</Link>
          <Link to="/register?role=tenant" className="hover:text-white" data-testid="footer-companies-link">{t("nav_companies")}</Link>
        </div>
        <div className="text-sm space-y-2">
          <a href="/HomeToB_logo.zip" download className="inline-flex items-center gap-2 text-[#FF6B00] hover:text-orange-300" data-testid="footer-logo-download">
            <Download className="h-4 w-4" />{t("download_logo")} (SVG + PNG)
          </a>
          <p className="text-slate-500">© {new Date().getFullYear()} HomeToB.it. {t("footer_rights")}</p>
        </div>
      </div>
    </footer>
  );
}
